
import React, { useState } from "react";
import { CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Users } from "lucide-react";
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";


const ChatHeader = ({ channel, activeTab }) => {
  const [showActiveUsers, setShowActiveUsers] = useState(false);

  return (
    <>
      <CardHeader className="pb-12 ph-24 pt-24 border-b">
        <div className="flex items-center justify-between">
          <CardTitle>{channel?.groupName}</CardTitle>
          <div className="flex items-center gap-2">
            <Badge 
              variant={activeTab === "Private" ? "success" : "outline"}
              className={activeTab === "Private" ? "" : "border-primary text-primary"}
              style={{borderRadius:'6px'}}
            >
              {activeTab === "Private" ? "Private" : "Public"}
            </Badge>
            <Button 
              variant="ghost" 
              size="icon"
              className="h-8 w-8" 
              onClick={() => setShowActiveUsers(true)}
              title="View active users"
            >
              <Users size={18} />
            </Button>
          </div>
        </div>
        <CardDescription>{channel?.description}</CardDescription>
      </CardHeader>

      <Dialog open={showActiveUsers} onOpenChange={setShowActiveUsers}>
        <DialogContent className="sm:max-w-md dark:bg-[#1A1F2C]">
          <DialogHeader>
            <DialogTitle className="dark:text-white">Active Users in {channel?.groupName}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="space-y-2">
              {channel?.employee?.map(user => (
                <div 
                  key={user?.id} 
                  className="flex items-center justify-between p-8 border rounded-md"
                >
                  <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full bg-green-500`}></div>
                    <span className="dark:text-white">{user?.firstName}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChatHeader;
